import {AudioMap} from "./types";

let _visibilityHandler: (() => void) | null = null

export const updateVisibilityHandler = (activeSounds: string[], audioMap: AudioMap) => {

    if (typeof document.hidden === "undefined") {
        console.warn("visibility API not supported, not pausing/resuming sounds")
        return
    }
    console.log("update visibility handler for ", activeSounds);
    if (_visibilityHandler) {
        console.log("removing previous listener");
        document.removeEventListener("visibilitychange", _visibilityHandler)
        _visibilityHandler = null
    }

    // update global var
    _visibilityHandler = () => {
        console.log("webyarns sounds visibilitychange");
        if (document.visibilityState === 'hidden') {
            console.log("visibility hidden: pausing sounds", activeSounds)
            activeSounds.forEach(id => {
                const sound = audioMap[id]
                if (sound && sound.playing()) {
                    console.log(`visibility change: pausing ${id}`);
                    sound.pause()
                }
            })
        } else {
            console.log("visibility visible: resuming sounds", activeSounds)
            const resumeSounds = () => {
                activeSounds.forEach(id => {
                    const sound = audioMap[id]
                    if (sound && !sound.playing()) {
                        console.log(`visibility change: resume ${id}`);
                        sound.play()
                    }
                })
            }

            if (Howler.ctx && Howler.ctx.state === 'suspended') {
                console.log("Resuming suspended AudioContext");
                Howler.ctx.resume().then(() => {
                    console.log("AudioContext resumed");
                    resumeSounds();
                });
            } else {
                resumeSounds();
            }
        }
    }
    document.addEventListener("visibilitychange", _visibilityHandler)
    if (document.visibilityState === 'hidden') {
        _visibilityHandler()
    }
}
